import HomeRoutes from './_config/home.routes';
import HomeComponent from './components/home';

const moduleName = 'app.gestion.home';

angular.module(moduleName, []).config(HomeRoutes).component('gestionHome', HomeComponent);

export default moduleName;
